import { sampleArticle } from "../projects/mockData.mjs";

const delay = (ms = 450) => new Promise((resolve) => setTimeout(resolve, ms));

export async function generateArticle(input) {
  await delay(20);
  if (isUrlOnlyLinkInput(input)) {
    throw new Error("当前纯本地模式不能读取网页链接。请用 npm.cmd run dev 启用服务端链接读取，或切换到“素材”粘贴文章正文后再生成。");
  }

  const title = normalizeTitle(getUsableSourceText(input));
  const article = {
    ...sampleArticle,
    id: `article-${Date.now()}`,
    title,
    titleCandidates: [
      title,
      `从单篇爆文到持续生产：${title}`,
      `公众号创作者如何理解${title.replace(/方法论$/, "")}`
    ]
  };

  return {
    recommendedTitle: title,
    titleCandidates: article.titleCandidates,
    article
  };
}

export async function reviewArticle(article) {
  await delay(20);
  return {
    score: 88,
    issues: [
      {
        id: "issue-fact",
        type: "fact",
        severity: "medium",
        targetSectionId: article.sections[1]?.id ?? "sec-beyond-draft",
        title: "事实待核",
        description: "涉及平台规则、增长数据或研究结论时，需要补充来源。",
        suggestion: "将绝对表述改为更稳妥的表达，并在发布前人工确认。"
      },
      {
        id: "issue-logic",
        type: "logic",
        severity: "low",
        targetSectionId: article.sections[0]?.id ?? "sec-process",
        title: "结构建议",
        description: "第一节可以补一句为什么公众号场景更需要结构化。",
        suggestion: "补充读者在碎片时间阅读、快速判断价值的上下文。"
      },
      {
        id: "issue-style",
        type: "style",
        severity: "high",
        targetSectionId: article.sections[2]?.id ?? "sec-system",
        title: "表达风险",
        description: "增长表述较笼统，建议说明是阅读、转发还是复访。",
        suggestion: "把增长目标拆成阅读完成率、转发率和复访率。"
      }
    ]
  };
}

export async function rewriteSelection({ selectedText, instruction }) {
  await delay(20);
  const trimmed = selectedText.trim();
  let suggestion = trimmed
    .replace("增长就会变得非常消耗", "增长就会持续消耗创作者的精力")
    .replace("更好的做法", "更可持续的做法")
    .replace("可以被工具放大，也可以被人工审校", "可以交给工具提效，也可以由人工把住判断和发布质量");

  if (/更短|精简/.test(instruction)) {
    suggestion = suggestion.replace("创作者的精力", "精力");
  }

  return { suggestion };
}

function isUrlOnlyLinkInput(input) {
  if (input?.inputType !== "link") return false;
  return stripUrls(input.sourceText).trim().length === 0 && /^https?:\/\//i.test(String(input.sourceText || "").trim());
}

function getUsableSourceText(input) {
  if (input?.inputType !== "link") return input.sourceText;
  return stripUrls(input.sourceText).trim() || input.sourceText;
}

function stripUrls(value) {
  return String(value || "").replace(/https?:\/\/\S+/gi, "");
}

function normalizeTitle(sourceText) {
  const firstLine = String(sourceText || "").split(/\r?\n/)[0].trim();
  if (!firstLine) return "未命名公众号文章";
  return firstLine.replace(/^主题[:：]\s*/, "").slice(0, 32);
}
